@use "ui/styles/colors";

.wrapper {
  position: relative;
  display: inline-block;

  :global {
    // TODO: make conditional on presence of new release notes or disable
    .indicator {
      position: absolute;
      top: 1px;
      right: 1px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: colors.$red;
    }
  }
}
